"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCheckboxStateForBulkActions = exports.usePagination = exports.getLastPageIndex = exports.convertObjsToValueLabel = void 0;
var React = __importStar(require("react"));
var types_1 = require("../../../types");
var convertObjsToValueLabel = function (items) {
    return Object.entries(items)
        .reduce(function (acc, cur) {
        var value = cur[0], label = cur[1];
        return __spreadArray(__spreadArray([], acc, true), [{ value: value, label: label }], false);
    }, [])
        .sort(function (a, b) { return (a.label > b.label ? 1 : -1); });
};
exports.convertObjsToValueLabel = convertObjsToValueLabel;
var getLastPageIndex = function (totalItems, itemsPerPage) {
    var index = Math.ceil(totalItems / itemsPerPage);
    return Math.max(1, index);
};
exports.getLastPageIndex = getLastPageIndex;
var usePagination = function (defaultItemsPerPage, defaultCurrentPage) {
    var itemsPerPageStateHooks = React.useState(defaultItemsPerPage);
    var currentPageStateHooks = React.useState(defaultCurrentPage);
    return [itemsPerPageStateHooks, currentPageStateHooks];
};
exports.usePagination = usePagination;
var getCheckboxStateForBulkActions = function (selected, rows) {
    var checkboxState = types_1.CheckboxStates.FALSE;
    var allRowsChecked = selected.length !== 0 && selected.length === rows.length;
    var someRowsChecked = selected.length !== 0 && selected.length !== rows.length;
    if (someRowsChecked) {
        checkboxState = types_1.CheckboxStates.INDETERMINATE;
    }
    if (allRowsChecked) {
        checkboxState = types_1.CheckboxStates.TRUE;
    }
    return checkboxState;
};
exports.getCheckboxStateForBulkActions = getCheckboxStateForBulkActions;
